import { UseQueryResult } from "@tanstack/react-query";

/**
 * Returns the mapped query result.
 *
 * @param query The query to map.
 * @param map The mapping function.
 * @returns The mapped query result.
 */
export function mapQuery<T, TTo>(
  query: UseQueryResult<T>,
  map: (data: T) => TTo,
): UseQueryResult<TTo> {
  // `UseQueryResult` is a discriminated union that pairs `data` with the status
  // flags, and it also carries a `promise` typed to the unmapped value. A single
  // spread can therefore never be comparable to it: the success member wants a
  // defined `data`, and `promise` stays `Promise<T>`. Rebuilding the union member
  // by member, or re-wrapping the promise, would cost a new promise per render
  // with no rejection handler, so the object is passed through unchanged.
  return {
    ...query,
    data: query.data ? map(query.data) : undefined,
  } as unknown as UseQueryResult<TTo>;
}
